// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entry[data-v-48866c0b]{display:flex;justify-content:space-between;align-items:center;border-top:1px solid #3d4850;padding-top:4px;margin-top:4px}.entry p[data-v-48866c0b]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
